import React, { useEffect, useState } from "react";
import { compareTwoDate } from "../../../utility/utils";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const RescheduleDatePicker = ({
  rescheduleDate,
  availableWorkingDays,
  timeSlots,
  setRescheduleDate,
  date,
  proposedDate,
  rescheduleTime,
  setRescheduleTime,
  availableWorkingTime = [],
  bookingType,
}) => {
  const { t } = useTranslation();
  const [allTimeSlots, setAllTimeSlots] = useState([]);
  const currentTime = new Date();

 
  useEffect(() => {
    try {
      const currentHours = currentTime.getHours();
      const currentMinutes = currentTime.getMinutes();
      let times = [];
  
      const filterTime = (timeSlots) => {
        return timeSlots.filter(({ time }) => {
          const [hours, minutes] = time.split(":").map(Number);
          return (
            hours > currentHours ||
            (hours === currentHours && minutes > currentMinutes)
          );
        });
      };
  
      if (bookingType) {
        if (bookingType === "waiting") {
          const exist = availableWorkingDays?.find(({ date }) =>
            compareTwoDate(date, rescheduleDate)
          )?.timeSlots;
  
          if (exist) {
            times = JSON.parse(JSON.stringify(exist)); // Deep copy
          }
        } else {
          times = JSON.parse(JSON.stringify(availableWorkingTime)); // Deep copy
        }
      } else {
        const exist = availableWorkingDays?.find(({ date }) =>
          compareTwoDate(date, rescheduleDate)
        )?.timeSlots;
  
        if (exist) {
          times = JSON.parse(JSON.stringify(exist)); // Deep copy
        }
      }
  
      if (times?.length > 0) {
        if (compareTwoDate(new Date(), rescheduleDate)) {
          times = filterTime(times);
        }
        setAllTimeSlots(times);
      }
    } catch (error) {
      console.log(error);
    }
  }, [rescheduleDate]);

  return (
    <>
      <input
        type="date"
        value={rescheduleDate}
        onChange={(e) => {
          const newDateValue = e.target.value;

          const available = availableWorkingDays.find(({ date }) => {
            return compareTwoDate(date, newDateValue);
          });

          if (!available) {
            toast.warn(t("serviceSettings.dateNotAvailable"));
            return;
          }

          if (!timeSlots && compareTwoDate(available.date, date)) {
            toast.warn(t("serviceSettings.dateNotAvailable"));
            return;
          }
          if (proposedDate && compareTwoDate(proposedDate, newDateValue)) {
            toast.warn(t("serviceSettings.dateNotAvailable"));
            return;
          }
          setRescheduleDate(newDateValue);
        }}
        className="w-full border border-gray-300 rounded mt-2 h-12 mb-1"
      />
      <>
        {rescheduleDate && timeSlots ? (
          <select
            value={rescheduleTime}
            onChange={(e) => {
              setRescheduleTime(e.target.value);
            }}
            className="w-28 border border-gray-300 rounded mt-2 h-12 mb-1"
          >
            <option selected value="">
              ---
            </option>
            {allTimeSlots?.map(({ time }) => (
              <option key={time} value={time}>
                {time}
              </option>
            ))}
          </select>
        ) : null}
      </>
    </>
  );
};

export default RescheduleDatePicker;
